import React from 'react';
import {Tab} from "@headlessui/react"
import {concatenate} from "services/string";

// Types ----

type TabRenderProps = {
    selected: boolean
    disabled: boolean
}

type TabButtonUnderlinedProps = {
    disabled?: boolean
    onSelect?: () => void
    children: React.ReactText
}

// Component ----

function TabButtonUnderlined({disabled, onSelect, children}: TabButtonUnderlinedProps) {
    const baseClasses = 'text-sm outline-offset-4'
    const unselectedClasses = 'text-gray-700'
    const selectedClasses = 'text-brand border-b-2 border-brand'
    const unselectedDisabledClasses = "text-gray-400 cursor-not-allowed"
    const selectedDisabledClasses = "text-gray-100 cursor-not-allowed"

    return (
      <Tab
        disabled={disabled}
        className={({selected}) => concatenate(
          (selected && !disabled) ? selectedClasses : null,
          (!selected && !disabled) ? unselectedClasses : null,
          (selected && disabled) ? selectedDisabledClasses : null,
          (!selected && disabled) ? unselectedDisabledClasses : null,
          baseClasses)
        }
      >
          {({selected}: TabRenderProps) => {
              // if (selected && onSelect) onSelect();
              return children;
          }}
      </Tab>
    );
}

export { TabButtonUnderlined };